import loginBgDefault from '@/assets/images/login-bg.png';
import logoWorks from '@/assets/images/logos/logo-works.png';
import logoYW from '@/assets/images/logos/yorkshire-water/logo.png';

export type ClientId = 'works-lite' | 'yorkshire-water';

export interface ClientTheme {
  primary: string;
  primaryHover: string;
  primaryForeground: string;
  sidebarActiveBg: string;
  sidebarActiveText: string;
}

export interface ClientFeatures {
  requestMoreInfo: boolean;
  bulkActions: boolean;
  callNow: boolean;
  helpPage: boolean;
  thirdPartyAccounts: boolean;
  durationChallenge: boolean;
  inactivityTimeoutMinutes: number | null;
}

export interface ClientConfig {
  id: ClientId;
  name: string;
  logo: string;
  logoHeight: string;
  logoWidth: string;
  loginBackground: string;
  theme: ClientTheme;
  features: ClientFeatures;
}

const worksLiteConfig: ClientConfig = {
  id: 'works-lite',
  name: 'Skewb Works Lite',
  logo: logoWorks,
  logoHeight: '32px',
  logoWidth: '120px',
  loginBackground: loginBgDefault,
  theme: {
    primary: '#E84A2B',
    primaryHover: '#d43d20',
    primaryForeground: '#ffffff',
    sidebarActiveBg: '#E84A2B',
    sidebarActiveText: '#ffffff',
  },
  features: {
    requestMoreInfo: true,
    bulkActions: true,
    callNow: true,
    helpPage: true,
    thirdPartyAccounts: true,
    durationChallenge: true,
    inactivityTimeoutMinutes: null,
  },
};

const yorkshireWaterConfig: ClientConfig = {
  id: 'yorkshire-water',
  name: 'Yorkshire Water',
  logo: logoYW,
  logoHeight: '40px',
  logoWidth: '104px',
  loginBackground: loginBgDefault,
  theme: {
    primary: '#003DA5',
    primaryHover: '#002d7a',
    primaryForeground: '#ffffff',
    sidebarActiveBg: '#003DA5',
    sidebarActiveText: '#ffffff',
  },
  features: {
    requestMoreInfo: false,
    bulkActions: false,
    callNow: false,
    helpPage: false,
    thirdPartyAccounts: false,
    durationChallenge: false,
    inactivityTimeoutMinutes: 30,
  },
};

const clients: Record<string, ClientConfig> = {
  'works-lite': worksLiteConfig,
  'yorkshire-water': yorkshireWaterConfig,
};

function resolveClientConfig(): ClientConfig {
  const brandKey = import.meta.env.VITE_APP_BRAND;
  if (brandKey && brandKey in clients) {
    return clients[brandKey];
  }
  return worksLiteConfig;
}

export const clientConfig = resolveClientConfig();
